export default __webpack_public_path__ + "static/stanzen-obj-4300f9e623e67acfa76d3998fb8a4604.png";